import { render } from "./HeaderVue.vue?vue&type=template&id=776e2f9c&scoped=true"
import script from "./HeaderVue.vue?vue&type=script&lang=js"
export * from "./HeaderVue.vue?vue&type=script&lang=js"

import "./HeaderVue.vue?vue&type=style&index=0&id=776e2f9c&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Lenovo\\OneDrive\\Documents\\Freelance\\symphinite\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-776e2f9c"]])

export default __exports__